import { render, staticRenderFns } from "./FollowupList.vue?vue&type=template&id=20ee9a63&scoped=true&"
import script from "./FollowupList.vue?vue&type=script&lang=js&"
export * from "./FollowupList.vue?vue&type=script&lang=js&"
import style0 from "./FollowupList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FollowupList.vue?vue&type=style&index=1&id=20ee9a63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee9a63",
  null
  
)

export default component.exports